import { SupportedTokenName } from "@mezo/sdk"
import { TooltipProps } from "@mezo-org/mezo-clay"

import {
  BITCOIN_MIN_DECIMALS,
  FRIENDLY_DECIMALS_AMOUNT,
} from "#/shared/constants"
import {
  bigIntToHumanReadableFormat,
  getCurrencySymbol,
  isBitcoinToken,
} from "#/shared/utils"

type OverviewTokenValueProps = Omit<TooltipProps, "content" | "children"> & {
  amount: bigint
  token: SupportedTokenName
  decimals: number
}

export default function OverviewTokenValue({
  amount,
  token,
  decimals,
}: OverviewTokenValueProps) {
  return (
    <>
      {bigIntToHumanReadableFormat(
        amount,
        decimals,
        isBitcoinToken(token) || token === "crv-stBTC"
          ? FRIENDLY_DECIMALS_AMOUNT
          : BITCOIN_MIN_DECIMALS,
      )}{" "}
      {getCurrencySymbol(token)}
    </>
  )
}
